export class DisposableBag {
  private _disposables = new Set<() => void>();

  add(dispose: () => void) {
    this._disposables.add(dispose);
    return this;
  }

  dispose() {
    this._disposables.forEach((dispose) => dispose());
    this._disposables.clear();
  }
}
